import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const { refresh } = useAuth();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking"); // checking, paid, failed

  useEffect(() => {
    if (!sessionId) { setStatus("failed"); return; }
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setStatus("paid"); refresh(); return; }
        if (["expired", "failed"].includes(data.payment_status)) { setStatus("failed"); return; }
      } catch { /* keep polling */ }
      if (++attempts < 8) setTimeout(poll, 2000);
      else setStatus("timeout");
    };
    poll();
  }, [sessionId]);

  return (
    <div className="flex min-h-[70vh] items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 text-center">
        {status === "checking" && (<><Loader2 className="mx-auto h-12 w-12 animate-spin text-blue-800" /><h1 className="mt-4 font-heading text-xl font-bold text-slate-900">Confirming your payment…</h1><p className="mt-1 text-sm text-slate-500">Please wait a moment.</p></>)}
        {status === "paid" && (<><CheckCircle2 className="mx-auto h-12 w-12 text-green-600" /><h1 className="mt-4 font-heading text-2xl font-bold text-slate-900">Payment Successful</h1><p className="mt-1 text-slate-500">Your listing has been upgraded and is now active.</p><Button asChild className="mt-6 bg-blue-800 hover:bg-blue-900"><Link to="/dashboard/listing">Back to My Listing</Link></Button></>)}
        {(status === "failed" || status === "timeout") && (<><XCircle className="mx-auto h-12 w-12 text-red-500" /><h1 className="mt-4 font-heading text-xl font-bold text-slate-900">{status === "timeout" ? "Still processing" : "Payment not completed"}</h1><p className="mt-1 text-sm text-slate-500">{status === "timeout" ? "It's taking longer than expected. Check your dashboard shortly." : "Your payment was not completed."}</p><Button asChild variant="outline" className="mt-6"><Link to="/dashboard/listing">Back to My Listing</Link></Button></>)}
      </div>
    </div>
  );
}
